<template>
  <div class="white">
    <div :style="{height: '550px', }" class="autoOverflow">
      <ValuesPickerNew :currentlyApplied="currentlyApplied" :callback="callback" />
    </div>
    <div class="allAroundPadding">
      <Flex>
        <Flex class="crossAxisCenter">
          <a
            class="button is-primary is-focused is-small"
            href="/advisor-dashboard/values/"
          >
            Edit Values Sets
          </a>
        </Flex>
        <Flex class="mainAxisFlexEnd crossAxisCenter rightMargin">
          <b-button @click="$parent.close" class="is-success">
            Apply
          </b-button>
        </Flex>
      </Flex>
    </div>
  </div>
</template>

<script>
import Flex from '@frontend/components/Flex.vue';
import ValuesPickerNew from '@frontend/components/ValuesPickerNew.vue';

export default {
  data() {
    return {
    };
  },
  components: {
    Flex,
    ValuesPickerNew,
  },
  props: {
    currentlyApplied: Array,
    callback: Function,
  },
  methods: {
  },
  computed: {
  },
  created: function() {
  },
};
</script>

<style lang="scss">
</style>
